import {  
    getFirestore,
    doc,
    collection,
    addDoc,
    setDoc
} from "firebase/firestore";
// import getOrgList from "./getOrgList";
const setOrgInfo = async function(data, id) {
    let db = getFirestore();
    let ref = collection(db, "wellness_org");
    if( id != undefined ){
        ref = doc(db, "wellness_org", id );
        await setDoc(ref, data);
    }
    else{
        const result = await addDoc(ref, data);
        id = result.id;
    }
    return id;
};
export default setOrgInfo;